import { useState } from 'react'

import { PlusCircleIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import VerticalDivider from '@/common/components/VerticalDivider/VerticalDivider'

import ConnectedActions from './ConnectedActions/ConnectedActions'
import * as Styles from './styles'

const Integration = ({ integration, onEdit, onToggle, onUninstall, disabled }) => {
  const theme = useTheme()
  const [isHovered, setIsHovered] = useState(false)

  const handleClick = () => {
    if (!integration.id) {
      onEdit(integration)
    }
  }

  return (
    <Styles.Container
      isConnected={integration?.id}
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Styles.InfoContainer>
        <Styles.Logo src={integration?.logo_url || '/images/placeholderImg.png'} alt={integration?.name} />
        <VerticalDivider />
        <Text type="bodyMBold">{integration?.name}</Text>
      </Styles.InfoContainer>
      <div>
        {!integration?.id ? (
          <PlusCircleIcon
            data-testid="plus-icon"
            size={32}
            color={theme.colors.outline.default}
            weight={isHovered ? 'fill' : 'thin'}
          />
        ) : (
          <ConnectedActions
            integration={integration}
            onToggle={onToggle}
            onUninstall={onUninstall}
            onEdit={onEdit}
            disabled={disabled}
          />
        )}
      </div>
    </Styles.Container>
  )
}

export default Integration
